import useAppMain from "src/hooks/useAppMain";
import {
  CLIENT_ROUTES,
  CLIENT_TAB_LIST,
  PATH_NAMES,
} from "src/utils/constants";
import { useNavigate } from "react-router-dom";
import { Flex, Text, Box, useMantineTheme } from "@mantine/core";
import { BsFillPeopleFill, BsFillPersonFill } from "react-icons/bs";
import {
  defaultEventFilters,
  useScheduleEventContext,
} from "src/api/context/ScheduleEventContext";
import { useEffect } from "react";

function EventType() {
  useAppMain(CLIENT_TAB_LIST.SCEDULE_EVENT, true);
  const navigate = useNavigate();
  const theme = useMantineTheme();
  const { filters, setFilters, setServices, setSearchedValue } =
    useScheduleEventContext();

  useEffect(() => {
    if (!filters.locations.length) {
      navigate(-1);
    }
  }, []);

  const handleNav = (bool: boolean) => {
    setSearchedValue("");
    setServices([]);
    setFilters({
      ...filters,
      isIndivdual: bool,
      dateRange: defaultEventFilters.dateRange,
    });

    navigate("/" + CLIENT_ROUTES.SCHEDULE_EVENTS);
  };

  return (
    <>
      <Text
        size={17}
        sx={{ borderBottom: `1px solid #DDDDDD`, textAlign: "center" }}
        color={theme.colors.secondaryTextColor[6]}
      >
        What kind of event do you want to book?
      </Text>

      <Flex direction={"column"} gap={"lg"} align={"center"} mt={40}>
        <Flex
          onClick={() => handleNav(false)}
          bg={theme.colors.primary[6]}
          sx={{
            //border: `1px solid #DDDDDD`,
            width: 180,
            height: 180,
            borderRadius: 4,
          }}
          align={"center"}
          direction={"column"}
          justify={"center"}
        >
          <BsFillPeopleFill
            size={50}
            color={theme.colors.primaryTextColor[6]}
          />
          <Text size={24} fw={500} color={theme.colors.primaryTextColor[6]}>
            Group
          </Text>
        </Flex>

        <Box sx={{ position: "relative" }}>
          <Text
            size={24}
            fw={500}
            sx={{
              ":before": {
                width: 30,
                content: '""',
                border: "1px solid #DDDDDD",
                position: "absolute",
                left: 35,
                top: "55%",
                transform: "translateY(-50%)",
              },
              ":after": {
                width: 30,
                content: '""',
                border: "1px solid #DDDDDD",
                position: "absolute",
                right: 35,
                top: "55%",
                transform: "translateY(-50%)",
              },
            }}
            color={theme.colors.secondaryTextColor[6]}
          >
            Or
          </Text>
        </Box>

        <Flex
          onClick={() => handleNav(true)}
          bg={theme.colors.primary[6]}
          sx={{
            //border: `1px solid #DDDDDD`,
            width: 180,
            height: 180,
            borderRadius: 4,
            cursor: "pointer",
          }}
          align={"center"}
          direction={"column"}
          justify={"center"}
        >
          <BsFillPersonFill
            size={50}
            color={theme.colors.primaryTextColor[6]}
          />
          <Text size={24} fw={500} color={theme.colors.primaryTextColor[6]}>
            Individual
          </Text>
        </Flex>
      </Flex>
    </>
  );
}

export default EventType;
